import React, { useState } from 'react';
import AdminSubPage from '../components/AdminSubPage';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

const AccrualsPage = () => {
  const [form, setForm] = useState({ till_date: '' });
  const [ran, setRan] = useState(false);

  const handleRun = (e) => {
    e.preventDefault();
    toast.success('Accruals processed successfully');
    setRan(true);
  };

  return (
    <AdminSubPage title="Accruals" breadcrumb={['Accounting', 'Accruals']} backPath="/dashboard/accounting">
      <form onSubmit={handleRun} className="bg-white border border-gray-200 p-6 max-w-md space-y-4">
        <p className="text-sm text-gray-500">Execute periodic accrual processing for interest income and expenses.</p>
        <div><Label>Accrue Till Date *</Label><Input type="date" value={form.till_date} onChange={e => setForm({...form, till_date: e.target.value})} required data-testid="accrual-date" /></div>
        <Button type="submit" className="bg-[#1f1f1f] text-white" data-testid="accrual-submit">Submit</Button>
      </form>
      {ran && <div className="mt-4 bg-green-50 border border-green-200 p-4 text-sm text-green-700">Accrual entries have been generated for the selected period.</div>}
    </AdminSubPage>
  );
};
export default AccrualsPage;
